var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container footer w-100 mt-5"},[_c('Advert',{attrs:{"adType":"footer"}}),_c(_vm.footerBody,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }